import * as ActionConst from './const';
import env from 'libs/env';
import { IOrder, ISubOrder } from 'types/order';

/**
 * @description 计算每一个子订单评论相关的操作
 * @param {Object} order 订单信息
 * @returns {{actions, level}} 操作按钮数组
 */
export const getSubOrderCommentAction = (order: ISubOrder) => {
    let action: string[] | null = null;

    if (order.comment_op === 1) {
        action = [ActionConst.CHECKOUT_COMMENT];
    } else if (order.comment_op === 2) {
        action =
            (env.isInToutiao || env.isInWechat) &&
            (!Object.prototype.hasOwnProperty.call(order, 'has_coupon_banner') ||
                order.has_coupon_banner === 1)
                ? [ActionConst.COMMENT_WITH_COUPON]
                : [ActionConst.PUBLISH_COMMENT];
    } else if (order.comment_op === 3) {
        action = [ActionConst.CHECKOUT_COMMENT];
    }

    return action;
};

export const hasMultiCommentOrder = (order: IOrder | ISubOrder): boolean => {
    if (!order.sub_orders) {
        return false;
    }

    return (
        order.sub_orders.reduce((num: number, subOrder: ISubOrder) => {
            if ([1, 2, 3].indexOf(subOrder.comment_op) !== -1) {
                return num + 1;
            }

            return num;
        }, 0) > 1
    );
};

const getCommentActionLevel = (order: ISubOrder) => {
    /**
     * 子订单是否有评论
     * 0 没有评论
     * 1 查看评价
     * 2 追加评价
     * 3 发表评价
     */
    if (order.comment_op === 1) {
        return 1;
    } else if (order.comment_op === 2) {
        return 3;
    } else if (order.comment_op === 3) {
        return 2;
    }

    return 0;
};

/**
 * @description 获取订单评论相关的操作
 * @param {Object} order 订单信息
 * @returns {{actions, level}} 操作按钮数组
 */
export const getOrderCommentAction = (order: IOrder) => {
    let commentAction: string[] | null = null;
    let commentLevel = 0;
    let commentOrderCounts = 0;

    order.sub_orders.forEach((subOrder) => {
        const action = getSubOrderCommentAction(subOrder);
        const actionLevel = getCommentActionLevel(subOrder);

        if (action) {
            commentOrderCounts += 1;
            if (actionLevel > commentLevel) {
                commentLevel = actionLevel;
                commentAction = action;
            }
        }
    });

    if (commentOrderCounts > 1 && commentAction) {
        commentAction = [commentAction[0]];
    }

    return commentAction as string[] | null;
};
